import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import AggregateEvent from './AggregateEvent';

export default class AggregateEvents extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'aggregateevent',
            data: null,
            loading: true,
            page: 1,
            per_page: 30,
            phrase: '',
        };
        this.state.filters = {
            type: props.Type,
            internalType: props.InternalType,
            companyName: '',
            internalStatus: 0
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type && props.InternalType == this.state.filters.internalType) return;
        this.state.filters.type = props.Type;
        this.state.filters.internalType = props.InternalType;
        this.refreshData();
    }
    onView(id) {
        this.removeKeyDown();
        this.showComponents({ component: <AggregateEvent Caller={this} Type={this.state.filters.type} Id={id} /> });
    }
    getCpations() {
        if (this.state.filters.type === 1) return "جلسات من";
        return "";
    }
    getCpation() {
        if (this.state.filters.type === 1) return "جلسه";
        return "";
    }
    renderForm() {
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست {this.getCpations()}</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} {this.getCpation} یافت شد</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="موضوع" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.companyName} onChange={e => this.state.filters.companyName = e.target.value} placeholder="نام شرکت" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <select
                                                    type="text"
                                                    defaultValue={this.state.filters.internalStatus}
                                                    onChange={(e) => this.state.filters.internalStatus = parseInt(e.target.value)}
                                                    className="form-control">
                                                    <option value="0">همه وضعیتها</option>
                                                    <option value="1">باز</option>
                                                    <option value="2">برگزار شده</option>
                                                    <option value="3">کنسل شده</option>
                                                    <option value="4">عدم حضور</option>
                                                    <option value="5">بسته شد</option>
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ نتیجه ای یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">موضوع</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">نحوه برگزاری</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شرکت</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">موضوع: </span>
                                                    <span className="sub-text text-center">{record.description}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">نحوه برگزاری: </span>
                                                    <span className="sub-text text-center">{record.internalTypeString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">تاریخ: </span>
                                                    <span className="sub-text text-center">{record.dateString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شرکت: </span>
                                                    <span className="sub-text text-center">{record.companyName}</span>
                                                </div>
                                                <div className="nk-tb-col text-end">
                                                    <a className="hand text-primary mx-1" onClick={e => this.onView(record.id)} title="مشاهده">
                                                        <i className="fa fa-eye"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}